import BatchOutputLog from "./batchOutputLog.vue";
export default BatchOutputLog;

